export enum LibraryType {
  Provider = 'provider',
  Personal = 'personal'
}

export enum LibraryName {
  Provider = 'Provider Library',
  Personal = 'My Library'
}
